const initialState = {
    schedules: {
        name: "",
        calendar: 1,
        occurrence: "",
        timezone: "",
        description: "",
        config: {
        }
    },
    dayFrequencyValidation: {
        hasErrors: false,
        errors: {
            isDayEmpty: false,
            isFromEmpty: false,
            isTheEmpty: false,
            hasDuplicates: false
        }
    }
}

export const schedulesReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'CREATE_SCHEDULE':
            return {
                ...state,
                schedules: {
                    ...action.payload.schedules // Merge new config updates
                }
            };
        case 'CREATE_SCHEDULE_CONFIG':
            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...action.payload.config // Merge new config updates
                    }
                }
            };
        case 'UPDATE_SCHEDULE':
            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    [action.payload.name]: action.payload.value
                }
            };
        case 'UPDATE_SCHEDULE_CONFIG':
            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config, // Preserve existing config data
                        ...action.payload.config // Merge new config updates
                    }
                }
            };
        case 'UPDATE_DATE_TIME':
            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config,
                        date_time: action.payload // Update date_time with the new array
                    }
                }
            };
        case "UPDATE_TIME": {
            const { index, value } = action.payload;
            const weekdays = state.schedules.config.weekdays;

            if (
                Array.isArray(weekdays) &&
                weekdays.length === 1 &&
                weekdays[0].day === "All"
            ) {
                const updatedWeekdays = weekdays.map((dayObj) => {
                    if (dayObj.day === "All") {
                        return {
                            ...dayObj,
                            time: dayObj.time.map((item, i) =>
                                i === index ? value : item
                            )
                        };
                    }
                    return dayObj;
                });

                return {
                    ...state,
                    schedules: {
                        ...state.schedules,
                        config: {
                            ...state.schedules.config,
                            weekdays: updatedWeekdays
                        }
                    }
                };
            }

            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config,
                        time: state.schedules.config.time.map((item, i) =>
                            i === index ? value : item
                        )
                    }
                }
            };
        }
        case "UPDATE_FIELD_IN_EVERY":
            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config,
                        every: {
                            ...state.schedules.config.every,
                            [action.payload.name]: action.payload.value
                        }
                    }
                }
            };
        case "UPDATE_FIELD_IN_WEEKDAY":
            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config,
                        weekdays: state.schedules.config.weekdays.map((dayObj) =>
                            dayObj.day === action.payload.day
                                ? { ...dayObj, [action.payload.name]: action.payload.value }
                                : dayObj
                        )
                    }
                }
            };
        case "ADD_ROW":
            const { field, value } = action.payload;
            if (field === "weekdays") {
                const updatedWeekdays = (state.schedules.config.weekdays || []).map(dayObj => {
                    if (dayObj.day === "All") {
                        return {
                            ...dayObj,
                            time: [...(dayObj.time || []), value]
                        };
                    }
                    return dayObj;
                });

                return {
                    ...state,
                    schedules: {
                        ...state.schedules,
                        config: {
                            ...state.schedules.config,
                            weekdays: updatedWeekdays
                        }
                    }
                };
            }

            // Default: push value into flat array (like time: [])
            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config,
                        [field]: [
                            ...(state.schedules.config[field] || []),
                            value
                        ]
                    }
                }
            };
        case "REMOVE_ROW":
            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config,
                        ...(action.payload.field === "time" &&
                            Array.isArray(state.schedules.config.weekdays) &&
                            state.schedules.config.weekdays[0]?.day === "All"
                            ? {
                                weekdays: [
                                    {
                                        ...state.schedules.config.weekdays[0],
                                        time: action.payload.updatedDateTime,
                                    },
                                    ...state.schedules.config.weekdays.slice(1),
                                ],
                            }
                            : {
                                [action.payload.field]: action.payload.updatedDateTime,
                            }),
                    },
                },
            };
        case "TOGGLE_DAY": {
            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config,
                        ...action.payload
                    }
                }
            };
        }
        case "ADD_TIME": {
            const { day, time } = action.payload;
            const weekdays = state.schedules.config.weekdays.map((d) =>
                d.day === day ? { ...d, time: [...d.time, time] } : d
            );

            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config,
                        weekdays
                    }
                }
            };
        }
        case "REMOVE_TIME": {
            const { day, index } = action.payload;
            const weekdays = state.schedules.config.weekdays.map((d) =>
                d.day === day ? { ...d, time: d.time.filter((_, i) => i !== index) } : d
            );

            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config,
                        weekdays
                    }
                }
            };
        }
        case "HANDLE_TIME": {
            const { day, index, time } = action.payload;

            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config,
                        weekdays: state.schedules.config.weekdays.map((d) =>
                            d.day === day
                                ? {
                                    ...d,
                                    time: d.time.map((t, i) =>
                                        i === index ? time : t
                                    ),
                                }
                                : d
                        ),
                    },
                },
            };
        }
        case "UPDATE_THE":
            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config,
                        the: action.payload,
                    }
                }
            };
        case "UPDATE_FROM":
            return {
                ...state,
                schedules: {
                    ...state.schedules,
                    config: {
                        ...state.schedules.config,
                        From: action.payload,
                    }
                }
            };
        case "SET_DAY_FREQUENCY_VALIDATION":
            return {
                ...state,
                dayFrequencyValidation: action.payload
            };
        case "SET_FORM_SUBMITTED":
            return {
                ...state,
                formSubmitted: action.payload
            };
        default:
            return state;

    }


};